import { produce } from "immer";
import {
  SEARCH_MOBILITY,
  SEARCH_MOBILITY_FAILURE,
  SEARCH_MOBILITY_SUCCESS,
  SEARCH_OBSERVATION,
  SEARCH_OBSERVATION_FAILURE,
  SEARCH_OBSERVATION_SUCCESS,
  SEARCH_REVIEW_SNAPSHOTS,
  SEARCH_REVIEW_SNAPSHOTS_FAILURE,
  SEARCH_REVIEW_SNAPSHOTS_SUCCESS,
  SEARCH_REVIEW_LOGS,
  SEARCH_REVIEW_LOGS_FAILURE,
  SEARCH_REVIEW_LOGS_SUCCESS,
  SEARCH_CARE_PLAN,
  SEARCH_CARE_PLAN_FAILURE,
  SEARCH_CARE_PLAN_SUCCESS,
  SEARCH_WARNING,
  SEARCH_WARNING_FAILURE,
  SEARCH_WARNING_SUCCESS,
  SEARCH_MAPPED_PLAN,
  SEARCH_MAPPED_PLAN_FAILURE,
  SEARCH_MAPPED_PLAN_SUCCESS,
} from "./constants";

export const initialState = {
  isSearching: false,
  searchList: [],
  isSearchingObservation: false,
  searchObservationList: [],
  isSearchingReviewSnapshots: false,
  reviewSnapshotsList: [],
  isSearchingReviewLogs: false,
  reviewLogsList: [],
  isSearchingCarePlan: false,
  carePlanList: [],
  isSearchingWarning: false,
  warningList: [],
  isSearchingMappedPlan: false,
  mappedPlanList: [],
};

const SearchReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SEARCH_MOBILITY:
        draft.isSearching = true;
        draft.searchList = [];
        break;
      case SEARCH_MOBILITY_SUCCESS:
        draft.isSearching = false;
        draft.searchList = action.payload;
        break;
      case SEARCH_MOBILITY_FAILURE:
        draft.isSearching = false;
        draft.searchList = [];
        break;
      case SEARCH_OBSERVATION:
        draft.isSearchingObservation = true;
        draft.searchObservationList = [];
        break;
      case SEARCH_OBSERVATION_SUCCESS:
        draft.isSearchingObservation = false;
        draft.searchObservationList = action.payload;
        break;
      case SEARCH_OBSERVATION_FAILURE:
        draft.isSearchingObservation = false;
        draft.searchObservationList = [];
        break;
      case SEARCH_REVIEW_SNAPSHOTS:
        draft.isSearchingReviewSnapshots = true;
        draft.reviewSnapshotsList = [];
        break;
      case SEARCH_REVIEW_SNAPSHOTS_SUCCESS:
        draft.isSearchingReviewSnapshots = false;
        draft.reviewSnapshotsList = action.payload;
        break;
      case SEARCH_REVIEW_SNAPSHOTS_FAILURE:
        draft.isSearchingReviewSnapshots = false;
        draft.reviewSnapshotsList = [];
        break;
      case SEARCH_REVIEW_LOGS:
        draft.isSearchingReviewLogs = true;
        draft.reviewLogsList = [];
        break;
      case SEARCH_REVIEW_LOGS_SUCCESS:
        draft.isSearchingReviewLogs = false;
        draft.reviewLogsList = action.payload;
        break;
      case SEARCH_REVIEW_LOGS_FAILURE:
        draft.isSearchingReviewLogs = false;
        draft.reviewLogsList = [];
        break;
      case SEARCH_CARE_PLAN:
        draft.isSearchingCarePlan = true;
        draft.carePlanList = [];
        break;
      case SEARCH_CARE_PLAN_SUCCESS:
        draft.isSearchingCarePlan = false;
        draft.carePlanList = action.payload;
        break;
      case SEARCH_CARE_PLAN_FAILURE:
        draft.isSearchingCarePlan = false;
        draft.carePlanList = [];
        break;
      case SEARCH_WARNING:
        draft.isSearchingWarning = true;
        draft.warningList = [];
        break;
      case SEARCH_WARNING_SUCCESS:
        draft.isSearchingWarning = false;
        draft.warningList = action.payload;
        break;
      case SEARCH_WARNING_FAILURE:
        draft.isSearchingWarning = false;
        draft.warningList = [];
        break;
      case SEARCH_MAPPED_PLAN:
        draft.isSearchingMappedPlan = true;
        draft.mappedPlanList = [];
        break;
      case SEARCH_MAPPED_PLAN_SUCCESS:
        draft.isSearchingMappedPlan = false;
        draft.mappedPlanList = action.payload;
        break;
      case SEARCH_MAPPED_PLAN_FAILURE:
        draft.isSearchingMappedPlan = false;
        draft.mappedPlanList = [];
        break;
      default:
        return state;
    }
  });

export default SearchReducer;
